// Логіка копіювання мега-меню в суб-меню колекції

// Функція копіювання мега-меню в суб-меню колекції
function copyMegaMenuToCollectionSubmenu() {
  try {
    const targetDiv = document.querySelector('.collection-submenu');
    const currentPath = window.location.pathname;

    if (!targetDiv) return;

    // Знаходимо активний елемент навігації
    const activeNavItem = document.querySelector(`.hover--mega-menu a[href='${currentPath}']`);

    if (activeNavItem) {
      // Знаходимо батьківський елемент з мега-меню
      const parentNavItem = activeNavItem.closest(".hover--mega-menu");
      const megamenuCol = parentNavItem ? parentNavItem.querySelector("#megamenu-col") : null;

      // Копіюємо HTML з мега-меню в суб-меню
      if (megamenuCol && megamenuCol.innerHTML.trim() !== '') {
        targetDiv.innerHTML = megamenuCol.innerHTML;
      } else {
        // Фолбек: шукаємо звичайний linklist
        const linklist = document.querySelector(`.mega-menu__linklist a[href='${currentPath}']`);
        if (linklist) {
          const linklistParent = linklist.closest('.mega-menu__linklist');
          if (linklistParent) {
            targetDiv.innerHTML = linklistParent.innerHTML;
          }
        }
      }

      // Трансформуємо елементи мега-меню в суб-меню
      transformMegaMenuToSubmenu(targetDiv);
    }
  } catch (error) {
    console.error("Error copying mega menu to collection submenu: ", error);
  }
}

// Функція обробки та трансформації елементів мега-меню в суб-меню
function transformMegaMenuToSubmenu(targetDiv) {
  try {
    // Знаходимо всі елементи hover--mega-menu
    const megaMenuItems = targetDiv.querySelectorAll('.hover--mega-menu');

    if (megaMenuItems.length === 0) return;

    // Отримуємо поточний шлях для визначення активної карточки
    const currentPath = window.location.pathname;

    // Очищуємо контейнер
    targetDiv.innerHTML = '';
    targetDiv.classList.add('collection-submenu--mega-menu');

    // Перетворюємо кожен елемент мега-меню в елемент суб-меню
    megaMenuItems.forEach((megaItem, index) => {
      const link = megaItem.querySelector('a[href]');
      const img = megaItem.querySelector('img');
      const titleElement = megaItem.querySelector('.title-class') || megaItem.querySelector('a:not([href*="cdn"])');

      if (link && img) {
        // Створюємо елемент суб-меню
        const card = document.createElement('a');
        card.href = link.href;
        card.className = 'collection-submenu__card from-mega-menu';
        card.setAttribute('data-snap-item', '');
        
        // Перевіряємо чи це активна карточка
        // Отримуємо тільки шлях з href (без домену)
        const linkPath = link.pathname || link.href.replace(window.location.origin, '');

        if (linkPath === currentPath || currentPath.includes(linkPath)) {
          card.classList.add('active');
        }

        // Створюємо контейнер для зображення
        const imageDiv = document.createElement('div');
        imageDiv.className = 'collection-submenu__image ';

        // Копіюємо зображення
        const newImg = document.createElement('img');
        newImg.src = img.src;
        newImg.alt = img.alt || `Item ${index + 1}`;
        newImg.loading = 'lazy';

        // Створюємо елемент для заголовка
        const title = document.createElement('p');
        title.className = 'collection-submenu__title';
        title.textContent = titleElement ? titleElement.textContent : `Item ${index + 1}`;

        // Збираємо все докупи
        imageDiv.appendChild(newImg);
        card.appendChild(imageDiv);
        card.appendChild(title);
        targetDiv.appendChild(card);
      }
    });
  } catch (error) {
    console.error("Error transforming mega menu to submenu: ", error);
  }
}


// Throttle helper function
function throttle(func, delay) {
  let timeoutId = null;
  let lastExecTime = 0;
  
  return function(...args) {
    const currentTime = Date.now();
    const timeSinceLastExec = currentTime - lastExecTime;
    
    if (timeSinceLastExec >= delay) {
      lastExecTime = currentTime;
      func.apply(this, args);
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        lastExecTime = Date.now();
        func.apply(this, args);
      }, delay - timeSinceLastExec);
    }
  };
}

// Функція для визначення чи потрібен скролінг і показу/приховування стрілок
function updateArrowVisibility(wrapper, scroller, prev, next) {
  if (!scroller || !prev || !next) return;
  
  const needsScroll = scroller.scrollWidth > scroller.clientWidth;
  const display = needsScroll ? 'flex' : 'none';
  
  prev.style.display = display;
  next.style.display = display;
}

// Функція для визначення чи контент вміщається і чи потрібне центрування
function updateCentering(scroller) {
  if (!scroller) return;
  
  const needsScroll = scroller.scrollWidth > scroller.clientWidth;
  
  if (needsScroll) {
    scroller.classList.remove('is-centered');
  } else {
    scroller.classList.add('is-centered');
  }
}

// Функція ініціалізації скролінгу та стрілок
function initializeSubmenuScrolling() {
  document.querySelectorAll('.collection-submenu__wrapper').forEach(wrapper => {
    const scroller = wrapper.querySelector('.collection-submenu');
    if (!scroller) return;

    const prev = wrapper.querySelector('.collection-submenu__arrow--prev');
    const next = wrapper.querySelector('.collection-submenu__arrow--next');

    if (!prev || !next) return;

    // Функція для визначення кроку скролінгу
    const step = () => {
      const card = scroller.querySelector('.collection-submenu__card');
      const gap = parseFloat(getComputedStyle(scroller).gap || 0);
      return (card ? card.offsetWidth : 145) + gap; // 145px - ширина карточки з CSS
    };

    // Обробники кліків по стрілках
    prev.addEventListener('click', () => {
      // Якщо на початку - перескакуємо в кінець
      if (scroller.scrollLeft <= 0) {
        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        scroller.scrollTo({ left: maxScroll, behavior: 'smooth' });
        return;
      }
      scroller.scrollBy({ left: -Math.min(step(), scroller.scrollLeft), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      const maxRight = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft;
      // Якщо в кінці - перескакуємо на початок
      if (maxRight <= 1) {
        scroller.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      scroller.scrollBy({ left: Math.min(step(), maxRight), behavior: 'smooth' });
    });

    // Функція позиціонування стрілок відносно зображень
    const positionArrows = () => {
      const imgBox = scroller.querySelector('.collection-submenu__image');
      if (!imgBox) return;
      const wrapRect = wrapper.getBoundingClientRect();
      const imgRect = imgBox.getBoundingClientRect();
      const centerY = imgRect.top - wrapRect.top + imgRect.height / 2;
      prev.style.top = next.style.top = `${centerY}px`;
    };

    // Функція оновлення UI (стрілки + центрування)
    const updateUI = () => {
      updateArrowVisibility(wrapper, scroller, prev, next);
      updateCentering(scroller);
      positionArrows();
    };

    // Throttled resize handler
    const throttledUpdate = throttle(updateUI, 150);

    // Події
    window.addEventListener('resize', throttledUpdate);
    window.addEventListener('load', updateUI);

    // Ініціалізація
    updateUI();
  });
}


// Викликаємо ініціалізацію скролінгу після завантаження сторінки
document.addEventListener("DOMContentLoaded", function () {
  // Перевірка чи є метафілд SubMenuNavigation.metafieldValue
  const hasSubmenuMetafield = document.querySelector('.collection-submenu') &&
                              (document.querySelector('.collection-submenu').hasAttribute('data-has-submenu-metafield') ||
                               document.querySelector('.collection-submenu .collection-submenu__card'));

  // Якщо метафілд пустий - копіюємо з мега-меню
  if (!hasSubmenuMetafield) {
    copyMegaMenuToCollectionSubmenu();
  }

  // Ініціалізуємо скролінг та стрілки
  initializeSubmenuScrolling();
  
  // Оновлюємо UI після невеликої затримки, щоб дати час на рендеринг
  setTimeout(() => {
    document.querySelectorAll('.collection-submenu__wrapper').forEach(wrapper => {
      const scroller = wrapper.querySelector('.collection-submenu');
      const prev = wrapper.querySelector('.collection-submenu__arrow--prev');
      const next = wrapper.querySelector('.collection-submenu__arrow--next');
      
      if (scroller && prev && next) {
        updateArrowVisibility(wrapper, scroller, prev, next);
        updateCentering(scroller);
      }
    });
  }, 100);
});